import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login_x: JSON.parse(sessionStorage.getItem('dola_user')) ? true : false,
    user_x: JSON.parse(sessionStorage.getItem('dola_user')) || {},
    waiter_x: JSON.parse(sessionStorage.getItem('dola_waiter')) || {},
    waiters_x: JSON.parse(sessionStorage.getItem('dola_waiters')) || [],
    shop_x: JSON.parse(sessionStorage.getItem('dola_shop')) || {},
    company_x: JSON.parse(sessionStorage.getItem('dola_company')) || {},
    reasonTemp_x: JSON.parse(sessionStorage.getItem('dola_reasonTemp')) || [],
    paytypes_x: [],
    paytypes2_x: [],
    scene_x: [],
    sceneId_x: '',
    // 獲取模式數據
    // 0 - 服务员餐桌二维码，B端控制主页上餐桌点单，
    // 1 - 总二维码，C端的总二维码，可以区分堂食和外卖，
    // 2 - 堂食点单(自助快餐)，用于B端判断主页是否显示，
    // 3 - 餐桌二维码点单（餐桌上固定的二维码点单），
    // 4 - 服务员出单二维码点单（拼桌二维码点单），
    // 5 - 服务员外卖点单（控制B端主页外卖，以及餐桌列表外卖），
    // 6 - 外卖平台点单
    modelList_x: [],
    defaultLogo_x: require('@/assets/images/logo-o-green.svg'),
    aliUrl_x: '',
    sysEnv_x: '',
    messageInstance_x: null,

    newFeedbackComing_x: 0,

    printer_x: JSON.parse(localStorage.getItem('dola_printer')) || {},
    reader_x: JSON.parse(localStorage.getItem('dola_reader')) || {},

    homePage_x: '',
    networkStatus_x: true,

    el_loading_x: false,
    el_loading_long_x: false,
    el_loading_coupon_select_x: false,

    menuCount_x: {
      itemsSellOutCount: 0,
      waitingOrderCount: 0,
      waitingBookCount: 0,
      lineUpCodeResponseList: [],
    },

    scan_canLeave_x: true,
    bellOpen_x: false,
    bellRing_x: false,
    bellOrderIds_x: JSON.parse(sessionStorage.getItem('dola_bellOrderIds')) || [],
    bell_timer: null,
  },
  getters: {
    printerId_x: state => state.printer_x[String(state.shop_x.id)],
    readerId_x: state => state.reader_x[String(state.shop_x.id)],
  },
  mutations: {
    user_x_save(state, data) {
      state.login_x = true
      state.user_x = data
      sessionStorage.setItem('dola_user', JSON.stringify(data))
    },
    user_x_clear(state, data) {
      state.login_x = false
      state.user_x = {}
      state.waiter_x = {}
      state.waiters_x = []
      state.shop_x = {}
      state.company_x = {}
      state.reasonTemp_x = []
      state.sceneId_x = ''
      state.modelList_x = []
      sessionStorage.removeItem('dola_user')
      sessionStorage.removeItem('dola_shop')
      sessionStorage.removeItem('dola_company')
      sessionStorage.removeItem('dola_waiter')
      sessionStorage.removeItem('dola_reasonTemp')
    },
    shop_x_save(state, data) {
      state.shop_x = data
      sessionStorage.setItem('dola_shop', JSON.stringify(data))
    },
    company_x_save(state, data) {
      state.company_x = data
      sessionStorage.setItem('dola_company', JSON.stringify(data))
    },
    waiter_x_save(state, data) {
      state.waiter_x = data
      sessionStorage.setItem('dola_waiter', JSON.stringify(data))
    },
    waiters_x_save(state, data) {
      state.waiters_x = data
      sessionStorage.setItem('dola_waiters', JSON.stringify(data))
    },
    reasonTemp_x_save(state, data) {
      state.reasonTemp_x = data
      sessionStorage.setItem('dola_reasonTemp', JSON.stringify(data))
    },
    sceneId_x_save(state, data) {
      state.sceneId_x = data
    },
    paytypes_x_save(state, data) {
      state.paytypes_x = data
    },
    paytypes2_x_save(state, data) {
      state.paytypes2_x = data
    },
    scene_x_save(state, data) {
      state.scene_x = data
    },
    modelList_x_save(state, data) {
      state.modelList_x = data
    },
    aliUrl_x_save(state, data) {
      state.aliUrl_x = data
    },
    sysEnv_x_save(state, data) {
      state.sysEnv_x = data
    },
    messageInstance_x_save(state, data) {
      state.messageInstance_x = data
    },
    newFeedbackComing_x_save(state, data) {
      state.newFeedbackComing_x = data
    },
    printerId_x_save(state, data) {
      state.printer_x = data
      localStorage.setItem('dola_printer', JSON.stringify(data))
    },
    readerId_x_save(state, data) {
      state.reader_x = data
      localStorage.setItem('dola_reader', JSON.stringify(data))
    },
    homePage_x_save(state, data) {
      state.homePage_x = data
    },
    networkStatus_x_save(state, data) {
      state.networkStatus_x = data
    },
    el_loading_x_save(state, data) {
      state.el_loading_x = data
    },
    el_loading_long_x_save(state, data) {
      state.el_loading_long_x = data
    },
    el_loading_coupon_select_x_save(state, data) {
      state.el_loading_coupon_select_x = data
    },
    menuCount_x_save(state, data) {
      state.menuCount_x = data
    },
    scan_canLeave_x_save(state, data) {
      state.scan_canLeave_x = data
    },
    bellOpen_x_save(state, data) {
      state.bellOpen_x = data
    },
    bellRing_x_save(state, data) {
      state.bellRing_x = data
    },
    bellRing_x_save_once(state, data) {
      if (!state.bellRing_x) {
        state.bellRing_x = true
        state.bell_timer = setTimeout(() => {
          state.bellRing_x = false
          clearTimeout(state.bell_timer)
        }, 5000)
      }
    },
    bellOrderIds_x_save(state, data) {
      const IDS_OLD = JSON.parse(JSON.stringify(state.bellOrderIds_x))
      let flag = false

      data.forEach(x1 => {
        if (!IDS_OLD.includes(x1)) {
          flag = true
        }
      })
      console.log(`%c是否响铃:`, 'color: #00f;', flag)

      if (flag) {
        clearTimeout(state.bell_timer)
      }

      state.bellRing_x = flag
      state.bellOrderIds_x = data
      sessionStorage.setItem('dola_bellOrderIds', JSON.stringify(data))
    },
  },
  actions: {

  }
})
